import styled from "styled-components";

const FormDiv = styled.div`

.input-label{
    font-weight: Bold;
    font-size: 16px;
    width:100%;
    color:rgb(38 38 38);
}

.MuiInputLabel-asterisk{
    color: red;
}

.form-control{
    width:100%;
}

.help{
    position: fixed;
    padding-left: 13px;
    color:black;
}

.Mui-disabled{background-color:rgb(237 237 237)}

`

export { FormDiv };